import * as actionTypes from '../actions/actionTypes';

const initialState = {
  footers: {
    footers: [],
    count: "",
    isLoading: false,
    isError: false
  },
  createFooterData: {},
  isLoading: false,
  isError: false,
  editFooter: {},
  editFooterData: {},
  deleteFooterData: {
    isLoading: false,
    isError: false,
    data: {}
  }  
}

const footerReducer = (state = initialState, action = {}) => {

  const newState = { ...state };

  switch (action.type) {
    case actionTypes.FETCH_FOOTER_LIST:
      return { ...newState, footers: { ...newState.footers, isLoading: true } };

    case actionTypes.FETCH_FOOTER_LIST_SUCCESS:
      return { ...newState, footers: { footers: [...action.payload], count: action.payload.totalCount, isLoading: false, isError: false } };

    case actionTypes.FETCH_FOOTER_LIST_FAILURE:
      return { isLoading: false, isError: true };
    
    case actionTypes.RESET_CREATE_FOOTER_CONFIG_STATE:
      return { ...newState, isLoading: false, createFooterData: {} };

    case actionTypes.CREATE_FOOTER:
      return { ...newState, isLoading: true, createFooterData: {} };

    case actionTypes.CREATE_FOOTER_SUCCESS:
      return { ...newState, isLoading: false, createFooterData: { ...action.payload } };

    case actionTypes.CREATE_FOOTER_FAILURE:
      return { ...newState, isLoading: false, isError: true, createFooterData: { ...action.payload } };

    case actionTypes.RESET_EDIT_FOOTER_CONFIG_STATE:
      return { ...newState, isLoading: false, editFooterData: {} };

    case actionTypes.EDIT_FOOTER:
      return { ...newState, isLoading: true };

    case actionTypes.EDIT_FOOTER_SUCCESS:
      return { ...newState, isLoading: false, editFooterData: { ...action.payload } };

    case actionTypes.EDIT_FOOTER_FAILURE:
      return { ...newState, isLoading: false, isError: true, editFooterData: { ...action.payload } };

    case actionTypes.DELETE_FOOTER:
      return { ...newState, deleteFooterData: { isLoading: true } };

    case actionTypes.DELETE_FOOTER_SUCCESS:
      return { ...newState, deleteFooterData: { isLoading: false, data: { ...action.payload } } };

    case actionTypes.DELETE_FOOTER_FAILURE:
      return { ...newState, deleteFooterData: { isLoading: false, data: { ...action.payload } } };

    default:
      return { ...newState };
  }
};


export default footerReducer;